export type {
    Props as MultiUserPickerProps,
    MultiUserPickerOption,
    MultiUserPickerOptionNew,
} from './multi-user-picker-dumb';
export { default as MultiUserPickerDumb } from './multi-user-picker-dumb';
